/**
 * Esc closes an open desktop submenu and returns focus to its parent.
 *
 * Horizon opens the header submenus on pointerenter and on focus, and closes
 * them on pointerleave / blur. There is no keyboard dismissal: a keyboard user
 * who tabs into "Guides", opens the panel, and then wants out has to tab
 * through all eight children. Esc is the expected control and it was the one
 * gap left in Ger's accessibility checklist.
 *
 * ⚠️ DOCUMENT-LEVEL LISTENER, ON PURPOSE. The header subtree is reconciled
 * about a second after load: nodes we inject there are stripped and attributes
 * we set are reverted (that is what killed the first mobile-accordion attempt).
 * A listener bound to `document` is not a node in that subtree, so it survives.
 * Do not "improve" this by attaching handlers to the menu items themselves.
 *
 * Closing is done by dispatching the same `pointerleave` the theme already
 * listens for, rather than by hiding the panel ourselves — so the component
 * updates its own `aria-expanded` and internal state instead of us fighting it.
 */
(function () {
  'use strict';

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var trigger = document.querySelector('.header-menu .menu-list__list-item [aria-expanded="true"]');
    if (!trigger) return;

    var item = trigger.closest('.menu-list__list-item');
    if (!item) return;

    try {
      // The theme's own close path. PointerEvent is not constructible in a few
      // older engines, so fall back to a plain Event of the same type.
      var evt;
      try {
        evt = new PointerEvent('pointerleave', { bubbles: false, cancelable: true });
      } catch (e) {
        evt = new Event('pointerleave', { bubbles: false, cancelable: true });
      }
      item.dispatchEvent(evt);
    } catch (e) {
      if (window.console && console.warn) console.warn('[rt-header-a11y]', e);
    }

    // Focus goes back to the parent, which is what Esc is expected to do —
    // leaving focus inside a panel that just closed strands the user.
    if (typeof trigger.focus === 'function') trigger.focus();
  });
})();
